module.exports = "<div class=\"row\">\r\n    <div class=\"col\">\r\n      <h2>Maintenance</h2>\r\n    </div>\r\n  </div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/maintenance/maintenance.component.html
// module id = ../../../../../src/app/dialogs/maintenance/maintenance.component.html
// module chunks = main